module.exports = __webpack_public_path__ + "img/firma.c174ca3d.png";